import './ConvertPage.css'
import {useEffect, useRef} from "react";
import DragFile from "../DragFile/DragFile";
import {useLocation} from "react-router-dom";

function ConvertPage() {
    const location = useLocation()
    const convertRef = useRef(null);
    useEffect(() => {
        const hash = location.hash.replace('#', '');
        if (hash === 'convert' && convertRef.current) {
            convertRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    return (
        <div id='convert' ref={convertRef}>
            <h1 className='convert_text'>Convert all images to JXL for free.</h1>
            <div>
                <p>No data is sent. The magic happens in your browser.&nbsp;
                    <div className='black'>How?
                        <div className='how'>We use C Libraries and WASM to convert your images clientside.</div>
                    </div>
                </p>
            </div>
            <br/>

            <DragFile/>
        </div>
    )
}

export default ConvertPage;